/**
 * The ServiceGateway API
 * The ServiceGateway provides APIs to interact with the Gintel Easy Business Communications Suite (EBCS)
 *
 * OpenAPI spec version: 1.14.31-SNAPSHOT
 * Contact: frank.paaske@gintel.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { Component } from '../model/component';
import { CreateServiceResponse } from '../model/createServiceResponse';
import { GetComponentResponse } from '../model/getComponentResponse';
import { GetServiceResponse } from '../model/getServiceResponse';
import { GetServiceTemplatesResponse } from '../model/getServiceTemplatesResponse';
import { GetServicesResponse } from '../model/getServicesResponse';
import { Response } from '../model/response';
import { SearchServiceResponse } from '../model/searchServiceResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { ServiceAdministrationServiceInterface }                            from './serviceAdministration.serviceInterface';


@Injectable()
export class ServiceAdministrationService implements ServiceAdministrationServiceInterface {

    protected basePath = 'http://localhost:8080/ServiceGateway/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param number 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addComponent1(number: string, body?: Component, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public addComponent1(number: string, body?: Component, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public addComponent1(number: string, body?: Component, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public addComponent1(number: string, body?: Component, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (number === null || number === undefined) {
            throw new Error('Required parameter number was null or undefined when calling addComponent1.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Response>(`${this.basePath}/service/${encodeURIComponent(String(number))}/component`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param templateId 
     * @param organization 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createService1(templateId: number, organization?: string, name?: string, observe?: 'body', reportProgress?: boolean): Observable<CreateServiceResponse>;
    public createService1(templateId: number, organization?: string, name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CreateServiceResponse>>;
    public createService1(templateId: number, organization?: string, name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CreateServiceResponse>>;
    public createService1(templateId: number, organization?: string, name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling createService1.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<CreateServiceResponse>(`${this.basePath}/service/serviceTemplate/${encodeURIComponent(String(templateId))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param number 
     * @param templateId 
     * @param organization 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createService2(number: string, templateId: number, organization?: string, name?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public createService2(number: string, templateId: number, organization?: string, name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public createService2(number: string, templateId: number, organization?: string, name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public createService2(number: string, templateId: number, organization?: string, name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (number === null || number === undefined) {
            throw new Error('Required parameter number was null or undefined when calling createService2.');
        }

        if (templateId === null || templateId === undefined) {
            throw new Error('Required parameter templateId was null or undefined when calling createService2.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.post<Response>(`${this.basePath}/service/${encodeURIComponent(String(number))}/${encodeURIComponent(String(templateId))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param number 
     * @param organization 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteService1(number: string, organization?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public deleteService1(number: string, organization?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public deleteService1(number: string, organization?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public deleteService1(number: string, organization?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (number === null || number === undefined) {
            throw new Error('Required parameter number was null or undefined when calling deleteService1.');
        }


        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/service/${encodeURIComponent(String(number))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceNumber 
     * @param componentId 
     * @param organization 
     * @param login 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, body?: Component, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, body?: Component, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, body?: Component, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, body?: Component, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceNumber === null || serviceNumber === undefined) {
            throw new Error('Required parameter serviceNumber was null or undefined when calling editComponent1.');
        }

        if (componentId === null || componentId === undefined) {
            throw new Error('Required parameter componentId was null or undefined when calling editComponent1.');
        }




        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Response>(`${this.basePath}/service/${encodeURIComponent(String(serviceNumber))}/component/${encodeURIComponent(String(componentId))}`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param number 
     * @param organization 
     * @param name 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public editServiceName1(number: string, organization?: string, name?: string, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public editServiceName1(number: string, organization?: string, name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public editServiceName1(number: string, organization?: string, name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public editServiceName1(number: string, organization?: string, name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (number === null || number === undefined) {
            throw new Error('Required parameter number was null or undefined when calling editServiceName1.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (name !== undefined && name !== null) {
            queryParameters = queryParameters.set('name', <any>name);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.put<Response>(`${this.basePath}/service/${encodeURIComponent(String(number))}`,
            null,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceNumber 
     * @param componentId 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetComponentResponse>;
    public getComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetComponentResponse>>;
    public getComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetComponentResponse>>;
    public getComponent1(serviceNumber: string, componentId: number, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceNumber === null || serviceNumber === undefined) {
            throw new Error('Required parameter serviceNumber was null or undefined when calling getComponent1.');
        }

        if (componentId === null || componentId === undefined) {
            throw new Error('Required parameter componentId was null or undefined when calling getComponent1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetComponentResponse>(`${this.basePath}/service/${encodeURIComponent(String(serviceNumber))}/component/${encodeURIComponent(String(componentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getInboundServices1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetServicesResponse>;
    public getInboundServices1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetServicesResponse>>;
    public getInboundServices1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetServicesResponse>>;
    public getInboundServices1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetServicesResponse>(`${this.basePath}/service/serviceIn`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getOutboundServices1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetServicesResponse>;
    public getOutboundServices1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetServicesResponse>>;
    public getOutboundServices1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetServicesResponse>>;
    public getOutboundServices1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetServicesResponse>(`${this.basePath}/service/serviceOut`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceNumber 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getService1(serviceNumber: string, organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetServiceResponse>;
    public getService1(serviceNumber: string, organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetServiceResponse>>;
    public getService1(serviceNumber: string, organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetServiceResponse>>;
    public getService1(serviceNumber: string, organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceNumber === null || serviceNumber === undefined) {
            throw new Error('Required parameter serviceNumber was null or undefined when calling getService1.');
        }



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetServiceResponse>(`${this.basePath}/service/${encodeURIComponent(String(serviceNumber))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getServiceTemplates1(organization?: string, login?: string, observe?: 'body', reportProgress?: boolean): Observable<GetServiceTemplatesResponse>;
    public getServiceTemplates1(organization?: string, login?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetServiceTemplatesResponse>>;
    public getServiceTemplates1(organization?: string, login?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetServiceTemplatesResponse>>;
    public getServiceTemplates1(organization?: string, login?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<GetServiceTemplatesResponse>(`${this.basePath}/service/serviceTemplate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param number 
     * @param componentId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeComponent1(number: string, componentId: number, observe?: 'body', reportProgress?: boolean): Observable<Response>;
    public removeComponent1(number: string, componentId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Response>>;
    public removeComponent1(number: string, componentId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Response>>;
    public removeComponent1(number: string, componentId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (number === null || number === undefined) {
            throw new Error('Required parameter number was null or undefined when calling removeComponent1.');
        }

        if (componentId === null || componentId === undefined) {
            throw new Error('Required parameter componentId was null or undefined when calling removeComponent1.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            '*/*'
        ];

        return this.httpClient.delete<Response>(`${this.basePath}/service/${encodeURIComponent(String(number))}/component/${encodeURIComponent(String(componentId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param organization 
     * @param login 
     * @param serviceNumber 
     * @param serviceOrganization 
     * @param serviceName 
     * @param serviceProvider 
     * @param entriesPerPage 
     * @param page 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchService1(organization?: string, login?: string, serviceNumber?: string, serviceOrganization?: string, serviceName?: string, serviceProvider?: string, entriesPerPage?: number, page?: number, observe?: 'body', reportProgress?: boolean): Observable<SearchServiceResponse>;
    public searchService1(organization?: string, login?: string, serviceNumber?: string, serviceOrganization?: string, serviceName?: string, serviceProvider?: string, entriesPerPage?: number, page?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchServiceResponse>>;
    public searchService1(organization?: string, login?: string, serviceNumber?: string, serviceOrganization?: string, serviceName?: string, serviceProvider?: string, entriesPerPage?: number, page?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchServiceResponse>>;
    public searchService1(organization?: string, login?: string, serviceNumber?: string, serviceOrganization?: string, serviceName?: string, serviceProvider?: string, entriesPerPage?: number, page?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {









        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceNumber !== undefined && serviceNumber !== null) {
            queryParameters = queryParameters.set('serviceNumber', <any>serviceNumber);
        }
        if (serviceOrganization !== undefined && serviceOrganization !== null) {
            queryParameters = queryParameters.set('serviceOrganization', <any>serviceOrganization);
        }
        if (serviceName !== undefined && serviceName !== null) {
            queryParameters = queryParameters.set('serviceName', <any>serviceName);
        }
        if (serviceProvider !== undefined && serviceProvider !== null) {
            queryParameters = queryParameters.set('serviceProvider', <any>serviceProvider);
        }
        if (entriesPerPage !== undefined && entriesPerPage !== null) {
            queryParameters = queryParameters.set('entriesPerPage', <any>entriesPerPage);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }

        let headers = this.defaultHeaders;
        if (organization !== undefined && organization !== null) {
            headers = headers.set('organization', String(organization));
        }
        if (login !== undefined && login !== null) {
            headers = headers.set('login', String(login));
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.get<SearchServiceResponse>(`${this.basePath}/service/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
